import type React from 'react'
import { useContext, useState } from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'
import DangerButton from '@/components/DangerButton'
import TextAreaInput from '@/components/input/TextAreaInput'
import ctx from '@/context/AppContext'
import type { ResetableSection } from '@/lib/apollo/mutation/reset-section'
import { useResetSectionMutation } from '@/lib/apollo/mutation/reset-section'
import { Colours } from '@/utils/styles'
export interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  confirmResetMessage: string
  buttonText: string
  section: ResetableSection
  requireReason?: boolean
}

const ConfirmContainer = styled.div`
  h5 {
    color: ${Colours.lightGray};
  }

  span {
    color: ${Colours.red};
    user-select: unset;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  button {
    width: 100%;
  }
`

const ResetSection: React.FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  buttonText,
  confirmResetMessage,
  section,
  requireReason = false,
}) => {
  const [confirming, setConfirming] = useState<boolean>(false)
  const [reason, setReason] = useState<string>('')

  const { personId } = useContext(ctx)
  const [callResetSection, { data }] = useResetSectionMutation()

  return (
    <div>
      {!confirming && (
        <div className="side-by-side-flex">
          <DangerButton onClick={() => setConfirming(true)}>{buttonText}</DangerButton>
        </div>
      )}
      {confirming && (
        <ConfirmContainer>
          <h5>{confirmResetMessage}</h5>
          {requireReason && (
            <TextAreaInput
              label="Reason for reset"
              value={reason}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setReason(e.target.value)
              }
            />
          )}
          <ButtonGroup>
            <DangerButton
              disabled={requireReason && reason.trim().length === 0}
              onClick={() =>
                callResetSection({
                  variables: {
                    customerId,
                    applicationId,
                    subjectId,
                    section: section,
                    reason: requireReason ? reason : undefined,
                    userId: personId,
                  },
                })
              }
            >
              Reset
            </DangerButton>
            <Button onClick={() => setConfirming(false)} $alternate>
              Cancel
            </Button>
          </ButtonGroup>
        </ConfirmContainer>
      )}
      {/* 
          RESET RESPONSE 
        */}
      {data && <div>{JSON.stringify(data)}</div>}
    </div>
  )
}

export default ResetSection
